/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconSlash = createReactComponent("outline", "slash", "IconSlash", [["path", { "d": "M17 5l-10 14", "key": "svg-0" }]]);

export { IconSlash as default };
//# sourceMappingURL=IconSlash.mjs.map
